import { Injectable } from '@angular/core';
import { Http, Response, Headers, ResponseContentType } from '@angular/http';
import { CostAnalysisPayrollDetail } from './costanalysispayrolldetails';
import { Observable } from 'rxjs/Observable';
import { CONFIGURATION } from '../app.config';

@Injectable()
export class CostAnalysisPayrollService {
    private _CostPayrollServiceReportUrl = CONFIGURATION.baseServiceUrl + 'payrolloverviewreportservice/';
    constructor(private _http: Http) { }

    getReportData(data:any): Observable<any> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.post(this._CostPayrollServiceReportUrl + 'v2/payrolloverviewreportdata',data, { headers: headers })
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
    downloadExcelReport(): any {
        const url = this._CostPayrollServiceReportUrl
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.get(url, { headers: headers, responseType: ResponseContentType.Blob }).map(
            (res) => {
                const a = document.createElement('a');
                document.body.appendChild(a);
                const blob = new Blob([res.blob()], { type: 'application/zip' });
                const downloadUrl = URL.createObjectURL(blob);
                window.open(downloadUrl);
            })
    }
    private handleError(error: Response) {
        // in a real world app, we may send the server to some remote logging infrastructure
        // instead of just logging it to the console
        console.error(error);
        return Observable.throw(error.json().error || 'Failed in web api(Server error) ');
    }
}



// WEBPACK FOOTER //
// ./src/app/costanalysispayroll/costanalysispayroll.service.ts